import { ButtonDetail, ButtonManageTestSequenceTag } from "../Common/Button";
import TooltipWrapper from "../Common/TooltipWrapper";
import ShowDataCell from "../Common/DataCell";
import APP_ROUTES from "src/routes/routes";
import TestPackageDetailIcon from "src/assets/images/test-package-detail.png";
import SequenceListIcon from "src/assets/images/sequence-list.png";

const getTestPackageDetailUrl = (id, params) => {
  const baseUrl = `${APP_ROUTES.TEST_PACKAGE}/${id}`;
  const queryParams = [];

  if (params?.page) {
    queryParams.push(`page=${params.page}`);
  }

  if (params?.condition) {
    queryParams.push(`condition=${params.condition}`);
  }

  if (params?.instanceId) {
    queryParams.push(`instanceId=${params.instanceId}`);
  }

  return queryParams.length > 0 ? `${baseUrl}?${queryParams.join("&")}` : baseUrl;
};

export const columns = ({ t, handleManageTestSequenceTagClick, redirectToSequenceList, params }) => [
  {
    dataField: "combination_id",
    text: t("list.table.id"),
    headerClass: "width-by-px-120 text-nowrap",
    formatter: (_, row) => <ShowDataCell data={row.combination_id} customClass="text-nowrwap" />,
  },
  {
    dataField: "yamcs_package",
    text: t("list.table.project_instance_name"),
    headerClass: "width-by-px-160 text-nowrap",
    formatter: (item) => <ShowDataCell data={item.name} customClass="text-nowrwap" />,
  },
  {
    dataField: "title",
    text: t("list.table.title"),
    headerClass: "width-by-px-160",
    formatter: (title) => <ShowDataCell data={title} customClass="text-nowrwap" />,
  },
  {
    dataField: "number_of_tags",
    text: t("list.table.number_of_tags"),
    headerClass: "width-by-px-110 text-nowrap",
  },
  {
    dataField: "number_of_sequences",
    text: t("list.table.number_of_sequences"),
    headerClass: "width-by-px-160 text-nowrap",
  },
  {
    dataField: "user_updated_by",
    text: t("list.table.updated_by"),
    headerClass: "width-by-px-160 text-nowrap",
    formatter: (_, row) => <ShowDataCell data={row?.user_updated_by?.name} />,
  },
  {
    dataField: "updated_at",
    text: t("list.table.updated_at"),
    headerClass: "width-by-px-110 text-nowrap",
    formatter: (_, row) => <span>{row?.updated_at}</span>,
  },
  {
    dataField: "",
    text: "",
    headerClass: "width-by-px-60",
    formatter: (_, row) => (
      <>
        <ButtonManageTestSequenceTag id={row.id} handleClick={() => handleManageTestSequenceTagClick(row)} />
      </>
    ),
  },
  {
    dataField: "",
    text: "",
    headerClass: "width-by-px-60",
    formatter: (_, row) => (
      <ButtonDetail
        id={row.id}
        toUrl={getTestPackageDetailUrl(row?.id, params)}
        translation="test-package"
        icon={
          <img
            src={TestPackageDetailIcon}
            className="width-by-px-24 heigth-by-px-20 text-dark-filter prevent-img-context-menu"
            alt="Test Package Detail icon"
            onContextMenu={(e) => e.preventDefault()}
          />
        }
      />
    ),
  },
  {
    dataField: "",
    text: "",
    headerClass: "width-by-px-60",
    formatter: (_, row) => (
      <TooltipWrapper id={`sequence_list-${row?.id}`} tooltipText={t("list.table.sequence_list")}>
        <button
          onClick={() => redirectToSequenceList(row)}
          className="btn btn-blank border-0 p-y-8 px-0"
          onFocus={(e) => {
            // immediately blurs after focus
            e.target.blur();
          }}
        >
          <img
            src={SequenceListIcon}
            className="width-by-px-20 heigth-by-px-24 text-dark-filter prevent-img-context-menu"
            alt="Sequence List icon"
            onContextMenu={(e) => e.preventDefault()}
          />
        </button>
      </TooltipWrapper>
    ),
  },
];
